"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionConfigType = exports.QuestionTypes = void 0;
var QuestionTypes;
(function (QuestionTypes) {
    QuestionTypes["CHOICES"] = "choices_options";
    QuestionTypes["OPEN_ENDED"] = "open_ended";
    QuestionTypes["SCALE"] = "scale";
    QuestionTypes["YES_NO"] = "yes_no";
    QuestionTypes["EMAIL"] = "email";
    QuestionTypes["ZIP_CODE"] = "zip_code";
    QuestionTypes["NUMBER"] = "number";
    QuestionTypes["GROUP"] = "group";
    QuestionTypes["STATEMENT"] = "statement";
    QuestionTypes["DROPDOWN"] = "dropdown";
    QuestionTypes["RANKING"] = "ranking";
})(QuestionTypes = exports.QuestionTypes || (exports.QuestionTypes = {}));
var QuestionConfigType;
(function (QuestionConfigType) {
    QuestionConfigType["DESCRIPTION"] = "description";
    QuestionConfigType["STEPS"] = "steps";
    QuestionConfigType["ALLOW_MULTI_CHOICE"] = "allow_multi_choice";
    QuestionConfigType["RANDOMIZE"] = "randomize";
    QuestionConfigType["DISPLAY_OTHER"] = "display_other";
    QuestionConfigType["REQUIRED"] = "required";
    QuestionConfigType["SCALE_LABEL_FIRST"] = "scale_label_first";
    QuestionConfigType["SCALE_LABEL_MIDDLE"] = "scale_label_middle";
    QuestionConfigType["SCALE_LABEL_LAST"] = "scale_label_last";
    QuestionConfigType["DEMOGRAPHIC"] = "demographic";
    QuestionConfigType["MIN_VALUE"] = "min_value";
    QuestionConfigType["MAX_VALUE"] = "max_value";
    QuestionConfigType["VERTICAL_ALIGNMENT"] = "vertical_alignment";
    QuestionConfigType["BUTTON_TEXT"] = "button_text";
    QuestionConfigType["SHOW_BUTTON"] = "show_button";
    QuestionConfigType["ALPHABETICAL_ORDER"] = "alphabetical_order";
    QuestionConfigType["MAX_SELECTION"] = "max_selection";
    QuestionConfigType["MIN_SELECTION"] = "min_selection";
    QuestionConfigType["IMAGE_URL"] = "image_url";
    QuestionConfigType["START_AT_ONE"] = "start_at_one";
    QuestionConfigType["DISPLAY_ON_LIVE_FEED"] = "display_on_live_feed";
    QuestionConfigType["HIDE_FROM_LIVE_FEED"] = "hide_from_live_feed";
    QuestionConfigType["ENRICH_WITH_SUB_TOPIC"] = "enrich_with_sub_topic";
})(QuestionConfigType = exports.QuestionConfigType || (exports.QuestionConfigType = {}));
//# sourceMappingURL=question.js.map